const { Component, Fragment } = React;

class LongReview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      readMore: true,
      bodyText: '',
    };


    this.readMoreRef = React.createRef();
  }

  UNSAFE_componentWillMount() {
    const { info, stringLength } = this.props;
    let readMoreBoolean = false;

    if (info.body !== null && info.body.length > stringLength) {
      readMoreBoolean = true;
    }
    this.setState({
      bodyText: info.body
        ? this.shortenString(info.body, stringLength)
        : '',
      readMore: readMoreBoolean,
    });
  }

  componentDidMount() {
    const { clickedReview, index } = this.props;

    if(clickedReview && this.state.readMore && index === 0) {
      this.timeoutId = setTimeout(() => {
        this.readMoreRef.current.click();
      }, 500);
    }
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

    shortenString = (sourceString, maxLength) => {
      const short = sourceString.substr(0, maxLength);

      if (/^\S/.test(sourceString.substr(maxLength))) {
        return short.replace(/\s+\S*$/, '');
      }

      return short;

    };

    showAll = () => {
      const { info } = this.props;

      this.setState({
        bodyText: info.body,
        readMore: false,
      });
    };

    render() {
      const { info } = this.props;
      const { bodyText, readMore } = this.state;
      const stars = Array(Math.floor(info.rating)).fill('');
      let daysAgo = '';

      if (info.postage === '0 days ago') {
        daysAgo = 'Today';
      } else if (info.postage === '1 days ago') {
        daysAgo = 'Yesterday';
      } else {
        daysAgo = info.postage;
      }

      const renderTitle = () => {
        let reviewHasTitle = typeof info.title !== 'undefined';
        return reviewHasTitle ? <p>{info.title}</p> : null;
      }

      return (
        <div className="review">
          <div className="reviewer-info">
            <div className="stars">
              {stars.map((star, index) => {
                return (
                  <span key={`${index}-star`} className="star">
                                    ★
                  </span>
                );
              })}
            </div>
            <div className="name">
              <img
                alt="avatar"
                src="https://cdn.sandals.com/sandals/v12/images/general/all-inclusive/home-v2/blue-avatar.svg"
              />
              <p>{info.author}</p>
            </div>
            <div className="source">
              <span>{daysAgo} on</span>{' '}
              <img
                alt={`${info.reviewSite} logo`}
                src={`https://cdn.sandals.com/sandals/v12/images/general/all-inclusive/home-v2/${info.reviewSite.toLowerCase()}-icon.svg`}
              />
              <span>{info.reviewSite}</span>
            </div>
            <div className="title">
              {renderTitle()}
            </div>
          </div>
          <div className="content">
            <p>
              {bodyText}
              {readMore && '...'}
            </p>
            {readMore && (
              <button
                ref={this.readMoreRef}
                className="read-more-label"
                onClick={() => this.showAll()}
              >
                            Read More{' '}
                <img
                  alt="read more"
                  src="https://cdn.sandals.com/sandals/v12/images/general/all-inclusive/home-v2/icon-readmore.svg"
                />
              </button>
            )}
          </div>
        </div>
      );
    }
}

LongReview.defaultProps = {
  stringLength: 200,
};

export default LongReview;
